import React, { useState, useEffect, useRef } from "react";
import "./Css/CustomerHistory.css";
import Header from "./Header";
import Loader from "./Loader.js";
import {
  ArrowLeft,
  Eye,
  AlertCircle,
  Car,
  CheckCircle2,
  Clock,
  BanknoteIcon,
  MessageSquareIcon,
  CheckIcon,
  XIcon,
  DollarSignIcon,
  ReceiptIcon,
} from "lucide-react";
import GreyArrow from "../assets/greyLeftAr.png";
import { Button } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { Modal, Form, Row, Col, InputGroup } from "react-bootstrap";
import {
  handleError,
  goBack,
  formatToYYYYMMDD,
} from "../CommonJquery/CommonJquery";
import {
  APL_LINK,
  server_post_data,
  customer_view_deatils,
  get_booking_data,
} from "../ServiceConnection/serviceconnection";
import ViewAgreeMentForm from "./ViewAgreeMentForm";
import AddManualEntryModal from "./Payment.js/AddManualEntryModal";
import Breadcrumb from "../CommonJquery/Breadcrumb.js";
const CustomerHistory = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("0");
  const [currentPage, setCurrentPage] = useState(1);
  const [editStaffData, seteditStaffData] = useState([]);
  const [SearchFilter, setFilteredData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [CarImgPath, SetCarImgPath] = useState();
  const [downloadForm2, SetDownloadForm2] = useState();
  const [SignImg, SetSignImg] = useState();
  const [DringImg, SetDringImg] = useState();
  // Pagination settings
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [formData, setFormData] = useState({
    rent: "",
    tolls: "",
    maintainance: "",
    damage: "",
    latefees: "",
    deposit: "",
  });
  const [total, setTotal] = useState(0);

  // Calculate total whenever form data changes
  useEffect(() => {
    const sum = Object.keys(formData)
      .filter((key) => key !== "remarks")
      .reduce((sum, key) => sum + (parseFloat(formData[key]) || 0), 0);

    setTotal(sum);
  }, [formData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const childRef2 = useRef();
  useEffect(() => {
    master_data_get(0, 1);
  }, []);

  const master_data_get = async (dataSearch, flag) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("customer_id", id);
    fd.append("filter_status", dataSearch);
    fd.append("flag", flag);
    await server_post_data(customer_view_deatils, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          console.log(Response.data)
          seteditStaffData(Response.data.message.user_data);
          setFilteredData(Response.data.message.user_data);
          setUserData(Response.data.message.user);
          SetCarImgPath(APL_LINK + Response.data.message.data_other_image);
          // setfilteredData(Response.data.message.user_data);
          SetSignImg(APL_LINK + Response.data.message.data_signature_image);
          SetDringImg(APL_LINK + Response.data.message.data_licence_image);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };

  const handleStatusChange = (e) => {
    setStatusFilter(e.target.value);
  };

  const handleFilter = () => {
    master_data_get(statusFilter, 2);
    setCurrentPage(1); // Reset to first page when filtering
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "Active":
        return "cust_hist_status_active";
      case "Completed":
        return "cust_hist_status_completed";
      case "Switched":
        return "cust_hist_status_switched";
      case "Repo":
        return "cust_hist_status_repo";
      default:
        return "";
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const [showModal, setShowModal] = useState(false);
  const [values, setValues] = useState();

  const handleShowModal = (data) => {
    setValues(data);
    // Pre-populate formData with values from backend when modal opens
    if (data) {
      setFormData({
        rent: data.per_date_charge || "0.00",
        tolls: data.total_tolls || "0.00",
        maintainance: data.total_maintance || "0.00",
        damage: data.total_damagefees || "0.00",
        latefees: data.total_latefees || "0.00",
        deposit: data.total_deposit || "0.00",
      });
    }
    setShowModal(!showModal);
  };

  // Calculate total whenever values change
  useEffect(() => {
    if (values) {
      const sum = parseFloat(values.total_balance || 0);
      setTotal(sum);
    }
  }, [values]);

  const mondayDayYearFormat = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  useEffect(() => {
    if (!searchTerm || searchTerm.trim() === "") {
      setFilteredData(editStaffData); // No filter if search is empty
    } else {
      const term = searchTerm.toLowerCase();
      const result = editStaffData.filter((item) => {
        const car = item.car_data?.[0];
        return (
          car?.car_name?.toLowerCase().includes(term) ||
          car?.car_tagline?.toLowerCase().includes(term) ||
          car?.car_no?.toLowerCase().includes(term)
        );
      });
      setFilteredData(result);
    }
  }, [searchTerm, editStaffData]);

  // Get paginated data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = SearchFilter
    ? SearchFilter.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = SearchFilter
    ? Math.ceil(SearchFilter.length / itemsPerPage)
    : 0;

  const getStatusBadge = (option) => {
    let status = "";
    let badgeClass = "badge";

    // Determine status based on step_for_booking
    switch (option.step_for_booking) {
      case "0":
        return (
          <div className="status-badge status-new">
            <Clock size={16} className="status-icon" />
            <span>New</span>
          </div>
        );
      case "1":
        return (
          <div className="status-badge status-inprogress">
            <Clock size={16} className="status-icon" />
            <span>InProgress</span>
          </div>
        );
      case "2":
        return option.fill_aggriment_status == "0" ? (
          <div className="status-badge status-not-signed">
            <AlertCircle size={16} className="status-icon" />
            <span>Agreement not signed</span>
          </div>
        ) : (
          <div className="status-badge status-signed">
            <CheckCircle2 size={16} className="status-icon" />
            <span>Agreement signed</span>
          </div>
        );
      case "3":
        return (
          <div className="status-badge status-ready">
            <CheckCircle2 size={16} className="status-icon" />
            <span>Ready for Pickup</span>
          </div>
        );
      case "4":
        return (
          <div className="status-badge status-ongoing">
            <Car size={16} className="status-icon" />
            <span>OnGoing</span>
          </div>
        );
      case "5":
        return (
          <div className="status-badge status-completed">
            <CheckCircle2 size={16} className="status-icon" />
            <span>Completed</span>
          </div>
        );
      case "6":
        return (
          <div className="status-badge status-switch">
            <CheckCircle2 size={16} className="status-icon" />
            <span>Switch Car</span>
          </div>
        );
      case "7":
        return (
          <div className="status-badge status-repo">
            <CheckCircle2 size={16} className="status-icon" />
            <span>Repossession</span>
          </div>
        );
      case "10":
        return (
          <div className="status-badge status-rejected">
            <AlertCircle size={16} className="status-icon" />
            <span>Rejected</span>
          </div>
        );
      default:
        return (
          <div className="status-badge">
            <Clock size={16} className="status-icon" />
            <span>Unknown</span>
          </div>
        );
    }
  };

  // Mock navigation functions
  const triggerDownloadPDF2 = async (option) => {
    let fd = new FormData();
    fd.append("booking_id", option.primary_id);
    await server_post_data(get_booking_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          console.log(Response.data)
          SetDownloadForm2(Response.data.message.data);
        }
      })
      .catch((error) => {
        handleError("network");
      });
  };

  const handleNavigateViewPage = (path, option) => {
    navigate(path, { state: { option, CarImgPath } });
  };

  // Generate pagination buttons
  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    // Page buttons
    // Show max 5 page buttons with current page in the middle when possible
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    // Adjust startPage if endPage is at maximum
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    return buttons;
  };

  return (
    <>
      <Header />
      {showLoaderAdmin && <Loader />}
      <div className="pageCntn_head">
        <div className="pageNameDiv">
          {/* <p>Customer History</p>

          <img src={GreyArrow} alt="Rapid Car Leasing" /> */}
          <Breadcrumb
          items={[
            { label: "Driver Management", path: "/Customers" },
            { label: "Driver All Reports", path: "/Customer-history" }, 
          ]}
          />
        </div>
        <Button
          onClick={goBack}
          startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
          className="Back_bttn_page"
        >
          Back
        </Button>
      </div>
      <div className="cust_hist_container">
        {/* Customer Details Card */}
        <div className="downLoad_PrintEnqury ">
          <ViewAgreeMentForm
            ref={childRef2}
            downloadForm2={downloadForm2}
            SignImg={SignImg}
            DringImg={DringImg}
          />
        </div>
        <div className="cust_hist_card mb-4">
          {/* <div className="cust_hist_card_header">
            <div className="cust_hist_header_container">
              <h3 className="cust_hist_title">Customer History </h3>
            </div>
          </div> */}

          <div className="cust_hist_card_body">
            <div className="row">
              <div className="col-md-3">
                <div className="cust_hist_info_box">
                  <p className="cust_hist_info_label">Driver Name</p>
                  <p className="cust_hist_info_value">
                    {userData && userData.name}
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="cust_hist_info_box">
                  <p className="cust_hist_info_label">Contact Details</p>
                  <p className="cust_hist_info_value">
                    {userData && userData.mobile_no}
                  </p>
                  <p className="cust_hist_info_email">
                    {userData && userData.email}
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="cust_hist_info_box">
                  <p className="cust_hist_info_label">Driving License No.</p>
                  <p className="cust_hist_info_value">
                    {userData && userData.driving_licence}
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="cust_hist_info_box">
                  <p className="cust_hist_info_label">Driver Status</p>
                  <div className="mt-1">
                    <span
                      className={`cust_hist_status_badge ${getStatusClass(
                        userData && userData.booking_status
                      )}`}
                    >
                      {userData?.booking_status === "Active"
                        ? "Active"
                        : "Inactive"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Booking History Card */}
        <div className="cust_hist_card">
          <div className="cust_hist_card_header">
            <div className="cust_hist_header_container">
              <h3 className="cust_hist_title">Booking History</h3>

              <div className="search-filter">
                <div className="cust_hist_search_container">
                  <svg
                    className="cust_hist_search_icon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <input
                    type="text"
                    className="cust_hist_search_input"
                    placeholder="Search bookings..."
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </div>

                <select
                  className="cust_hist_select"
                  value={statusFilter}
                  onChange={handleStatusChange}
                >
                  <option value="0">All Statuses</option>
                  {/* <option value="completed">New</option> */}
                  {/* <option value="active">In Progress</option> */}
                  {/* <option value="pending">Ready For Pickup</option> */}
                  <option value="5">Completed</option>
                  <option value="6">Switch</option>
                  <option value="7">Repo</option>
                  {/* <option value="pending">Rejected</option> */}
                </select>

                <button
                  className="cust_hist_filter_button"
                  onClick={handleFilter}
                >
                  Filter
                </button>
              </div>
            </div>
          </div>

          {/* New Table Design */}
          <div className="reservationHistoryTable">
            <div
              className="historyTableContainer stickyTableheigh274"
              style={{ overflowX: "auto" }}
            >
              <table className="table margin_class_table">
                <thead className="stickyHeaderClss">
                  <tr>
                    <th scope="col">Sr.No.</th>
                    <th scope="col">Car Details</th>
                    <th scope="col">Pickup/Drop Dates</th>
                    <th scope="col">Booking Status</th>
                    <th scope="col">Balance/Dues</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody className="custum_border">
                  {currentItems && currentItems.length > 0 ? (
                    currentItems.map((option, index) => (
                      <tr className="historyTableRow" key={index}>
                        <td>
                          <div
                            style={{
                              marginLeft: "1rem",
                              fontSize: "14px",
                              marginTop: "1.2rem",
                            }}
                          >
                            {indexOfFirstItem + index + 1}
                          </div>
                        </td>
                        <td>
                          <div className="topMargin historyTime">
                            <div className="historyTimeImgText align-items-start">
                              {/* <Calendar strokeWidth={1.5} className="tble_icon" /> */}
                              <p>
                                {option.car_data &&
                                  option.car_data.length > 0 &&
                                  option.car_data[0].car_name}
                                (
                                {option.car_data &&
                                  option.car_data.length > 0 &&
                                  option.car_data[0].car_tagline}
                                )
                                <p>
                                  {option.car_data &&
                                    option.car_data.length > 0 &&
                                    option.car_data[0].car_no}
                                </p>
                                <p>
                                  VIN No.:{" "}
                                  {option.car_data &&
                                    option.car_data.length > 0 &&
                                    option.car_data[0].vin}
                                </p>
                              </p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="historyTableRowText historyName">
                            <p>
                              {" "}
                              <strong>Pickup Date:</strong>{" "}
                              {mondayDayYearFormat(option.from_date)}
                            </p>
                            <p>
                              {" "}
                              <strong>Dropoff Date:</strong>{" "}
                              {mondayDayYearFormat(option.end_date)}
                            </p>
                          </div>
                        </td>
                        <td>
                          <div className="historyTableRowText historyStatus">
                            {getStatusBadge(option)}
                          </div>
                        </td>
                        <td>
                          <div
                            className="historyTableRowText historyPerson"
                            style={{ flexWrap: "wrap" }}
                          >
                            <p>
                              <strong style={{ color: "green" }}>
                                Total Amount:
                              </strong>{" "}
                              ${option?.total_amount || 0}
                            </p>
                            <p>
                              <strong style={{ color: "red" }}>Due:</strong> $
                              {option?.total_due || 0}
                            </p>
                            <p>
                              <strong style={{ color: "orange" }}>
                                Advance:
                              </strong>{" "}
                              ${option?.total_advance || 0}
                            </p>
                          </div>
                        </td>
                        <td>
                          <div className="historyActionsBtns mb-2">
                            <div className="Action_booking_btn">
                              <button
                                className="instructions Add_Instructions"
                                title="Download Agreement"
                                style={{
                                  cursor: "pointer",
                                  paddingRight: "10px",
                                }}
                                onClick={() => triggerDownloadPDF2(option)}
                              >
                                View Agreement
                                {/* <Download size={16} /> */}
                              </button>
                              <button
                                className="instructions Add_Instructions"
                                title="Total Balance"
                                style={{
                                  cursor: "pointer",
                                  paddingRight: "10px",
                                }}
                                onClick={() => handleShowModal(option)}
                              >
                                Total Balance
                                {/* <Download size={16} /> */}
                              </button>
                            </div>

                            <div className="Action_booking_btn">
                              <button
                                className="instructions Add_Instructions"
                                title="View Pickup"
                                onClick={() =>
                                  handleNavigateViewPage(
                                    "/PickupFormPreview",
                                    option
                                  )
                                }
                              >
                                View Pickup <Eye size={16} />
                              </button>
                              {option.step_for_booking != "7" && (
                                <button
                                  className="instructions Add_Instructions"
                                  title="View Drop"
                                  onClick={() =>
                                    handleNavigateViewPage(
                                      "/DropoffFormPreview",
                                      option
                                    )
                                  }
                                >
                                  View Drop <Eye size={16} />
                                </button>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} className="text_align_center">
                        No Results Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="cust_hist_card_footer">
            <div className="cust_hist_pagination_info">
              {SearchFilter && SearchFilter.length > 0 ? (
                <>
                  Showing{" "}
                  <span className="cust_hist_pagination_bold">
                    {indexOfFirstItem + 1}
                  </span>{" "}
                  to{" "}
                  <span className="cust_hist_pagination_bold">
                    {Math.min(indexOfLastItem, SearchFilter.length)}
                  </span>{" "}
                  of{" "}
                  <span className="cust_hist_pagination_bold">
                    {SearchFilter.length}
                  </span>{" "}
                  rentals
                </>
              ) : (
                <>
                  Showing <span className="cust_hist_pagination_bold">0</span>{" "}
                  rentals
                </>
              )}
            </div>
            <div className="cust_hist_pagination">
              <nav aria-label="Pagination">
                <ul className="cust_hist_pagination_list">
                  {renderPaginationButtons()}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      {/* <Modal show={showModal} centered scrollable onHide={handleShowModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h5 className="your_total_blnce">Your Total Balance</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="summary-container">
                        <table className="summary-table">
                            <tbody>
                                <tr>
                                    {console.log(values)}
                                    <td>Rent</td>
                                    <td className="amount">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={values && values['per_date_charge']}
                                            readOnly
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Used Tolls Bal till</td>
                                    <td className="amount">
                                        <input
                                            type="text"
                                            className="form-control"
                                            
                                            readOnly
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Maintainance</td>
                                    <td className="amount">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={values && values['total_maintance']}
                                            readOnly
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Damage & Others</td>
                                    <td className="amount">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={values && values['total_damagefees']}
                                            readOnly
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Late Fees</td>
                                    <td className="amount">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={values && values['total_latefees']}
                                            readOnly

                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Balance for Deposit</td>
                                    <td className="amount">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={values && values['total_deposit']}
                                            readOnly

                                        />
                                    </td>
                                </tr>
                                <tr className="total-row">
                                    <td>Total</td>
                                    <td className="amount">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={values && values['total_balance']}
                                            readOnly
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
              
            </Modal> */}
      {/* */}
      <Modal
        show={showModal}
        onHide={handleShowModal}
        size="lg"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header
          className="text-white"
          style={{ backgroundColor: "var(--primary-color)" }}
        >
          <Modal.Title className="d-flex align-items-center">
            <BanknoteIcon className="me-2" size={24} />
            Your Total Balance
          </Modal.Title>
          <Button
            variant="link"
            className="close-button text-white"
            onClick={handleShowModal}
          >
            <XIcon size={34} />
          </Button>
        </Modal.Header>

        <Modal.Body className="px-4 py-4">
          <div className="payment-section mb-4">
            <Row className="mb-4 g-3">
              <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-bold">Rent</Form.Label>
                  <InputGroup>
                    <InputGroup.Text
                      className="bg-light"
                      style={{ marginTop: "5px" }}
                    >
                      <DollarSignIcon size={16} />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="rent"
                      value={values?.per_date_charge || "0.00"}
                      readOnly
                      className="form-control-lg bg-light"
                    />
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-bold">Tolls</Form.Label>
                  <InputGroup>
                    <InputGroup.Text
                      className="bg-light"
                      style={{ marginTop: "5px" }}
                    >
                      <DollarSignIcon size={16} />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="tolls"
                      value={values?.total_tolls || "0.00"}
                      readOnly
                      className="form-control-lg bg-light"
                    />
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-bold">Damage</Form.Label>
                  <InputGroup>
                    <InputGroup.Text
                      className="bg-light"
                      style={{ marginTop: "5px" }}
                    >
                      <DollarSignIcon size={16} />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="maintainance"
                      value={values?.total_maintance || "0.00"}
                      readOnly
                      className="form-control-lg bg-light"
                    />
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-4 g-3">
              <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-bold">Tickets</Form.Label>
                  <InputGroup>
                    <InputGroup.Text
                      className="bg-light"
                      style={{ marginTop: "5px" }}
                    >
                      <DollarSignIcon size={16} />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="damage"
                      value={values?.total_damagefees || "0.00"}
                      readOnly
                      className="form-control-lg bg-light"
                    />
                  </InputGroup>
                </Form.Group>
              </Col>

              {/* <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-bold">Late Fees</Form.Label>
                  <InputGroup>
                    <InputGroup.Text
                      className="bg-light"
                      style={{ marginTop: "5px" }}
                    >
                      <DollarSignIcon size={16} />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="latefees"
                      value={values?.total_latefees || "0.00"}
                      readOnly
                      className="form-control-lg bg-light"
                    />
                  </InputGroup>
                </Form.Group>
              </Col> */}

              <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-bold">
                    Balance for Deposit
                  </Form.Label>
                  <InputGroup>
                    <InputGroup.Text
                      className="bg-light"
                      style={{ marginTop: "5px" }}
                    >
                      <DollarSignIcon size={16} />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="deposit"
                      value={values?.total_deposit || "0.00"}
                      readOnly
                      className="form-control-lg bg-light"
                    />
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>

            {/* Total Amount with border above */}
            <Row
              className="mt-4 pt-3"
              style={{ borderTop: "2px solid #dee2e6" }}
            >
              <Col md={4} className="ms-auto">
                <Form.Group>
                  <Form.Label className="fw-bold">Total Amount</Form.Label>
                  <InputGroup>
                    <InputGroup.Text
                      className="bg-light"
                      style={{ marginTop: "5px" }}
                    >
                      <DollarSignIcon size={16} />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={values?.total_balance || "0.00"}
                      readOnly
                      className="form-control-lg bg-light fw-bold text-primary"
                    />
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={4} className="ms-auto">
                <Form.Group>
                  <Form.Label className="fw-bold">
                    Total Outstanding Dues
                  </Form.Label>
                  <InputGroup>
                    <InputGroup.Text
                      className="bg-light"
                      style={{ marginTop: "5px" }}
                    >
                      <DollarSignIcon size={16} />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={values?.total_balance || "0.00"}
                      readOnly
                      className="form-control-lg bg-light fw-bold text-primary"
                    />
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={4} className="ms-auto">
                <Form.Group>
                  <Form.Label className="fw-bold">Total Balance</Form.Label>
                  <InputGroup>
                    <InputGroup.Text
                      className="bg-light"
                      style={{ marginTop: "5px" }}
                    >
                      <DollarSignIcon size={16} />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={values?.total_balance || "0.00"}
                      readOnly
                      className="form-control-lg bg-light fw-bold text-primary"
                    />
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
          </div>
        </Modal.Body>

        <style jsx>{`
          .section-title {
            color: #495057;
            border-bottom: 1px solid #e9ecef;
            padding-bottom: 8px;
          }

          .payment-section,
          .remarks-section {
            background-color: #ffffff;
            border-radius: 8px;
          }

          .form-control-lg {
            height: 50px;
            font-size: 16px;
          }

          .form-control:focus {
            border-color: #80bdff;
            box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
          }

          .close-button {
            box-shadow: none !important;
            padding: 0;
            margin: 0;
            left: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .modal-content {
            border-radius: 10px;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
            border: none;
          }

          .input-group-text {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
          }
        `}</style>
      </Modal>
    </>
  );
};

export default CustomerHistory;
